import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';
import { SwiperOptions } from 'swiper/types/swiper-options';

import { SwiperDirective } from 'src/app/shared/directives/swiper.directive';

import { AuthService } from 'src/app/core/services/auth.service';
import { GoogleAnalyticService } from 'src/app/core/services/google-analytic.service';
import { FavoritesProviderService } from 'src/app/core/services/favorites-provider.service';

import { IViatorEvent } from '../viator.component';

import { Virtual } from 'swiper/modules';

@Component({
  selector: 'app-viator-group',
  templateUrl: './viator-group.component.html',
  styleUrls: ['./viator-group.component.scss'],
  imports: [NgxSkeletonLoaderModule, MatIconModule, SwiperDirective],
})
export class ViatorGroupComponent {
  @Input() placeId: string | number = 0;
  @Input() countryName: string = '';
  @Input() cityName: string = '';
  @Input() events: IViatorEvent[] = [];
  @Input() isFetching: boolean = false;
  @Output() bookNow = new EventEmitter<IViatorEvent>();

  @ViewChild('viatorGroupContainer') swiperContainer: ElementRef;

  public readonly eSvgIcons = ESvgIcons;
  public fetchingItems: number[] = new Array(12).fill(0).map((_, i) => i);

  constructor(
    protected readonly favoritesProviderService: FavoritesProviderService,
    protected readonly googleAnalyticService: GoogleAnalyticService,
    protected readonly authService: AuthService,
    private cdr: ChangeDetectorRef,
  ) {}

  public swiperOptions: SwiperOptions = {
    modules: [Virtual],
    lazyPreloadPrevNext: 2,
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 24,
    breakpoints: {
      320: {
        slidesPerView: 'auto',
        spaceBetween: 24,
      },
    },
    navigation: {
      disabledClass: 'rpf-swiper-btn-disabled',
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };

  toggleHurt(e: Event, viator: any): void {
    e.preventDefault();
    e.stopPropagation();

    this.favoritesProviderService.checkUserAuth(
      {
        favoriteId: viator.id,
        placeId: Number(this.placeId),
        provider: 'viator',
      },
      viator,
      this.cityName,
      (isDelete) => {
        if (!isDelete) {
          this.googleAnalyticService.setAddToWishlistAnalytic({
            whishlist_category: 'activities',
            merchant: 'viatour',
            service_country: this.countryName,
            service_city: this.cityName,
            category_name: 'activities',
            service_title: `activities: ${viator.name}`,
            userID: this.authService.userId,
          });
        }
        this.cdr.markForCheck();
      },
    );
  }
}
